import * as React from 'react'

import { IItem } from '../../../../typings/searchResults'
import ItemCard from '../itemCard'

import * as styles from './gridVideo.module.css'

const GridVideo = ({
  items,
  viewType,
  videoMuted,
  muteVideo,
  currentSite,
  itemDecorator
}: {
  items: any
  viewType: string
  videoMuted?: boolean
  muteVideo?: () => void
  currentSite: string
  itemDecorator: any
}) => {
  return (
    <ul data-test-selector="grid-layout" className={styles.grid}>
      {items.map((item: IItem, index: number) => {
        return (
          <li className={styles.result} key={item.id}>
            <ItemCard
              videoMuted={videoMuted}
              muteVideo={muteVideo}
              currentSite={currentSite}
              viewType={viewType}
              itemProps={itemDecorator(item, index)}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default GridVideo
